module.exports = __webpack_public_path__ + "static/img/788x478.c11f7ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/788x478.png
// module id = 0Qzo
// module chunks = 0